<template>
  <div class="main">
    <!-- Add Project Button -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-end">
          <b-modal
            id="modal-add-project"
            ok-only
            ok-title="Add"
            centered
            size="lg"
            title="Add Project"
            :hide-footer="true"
            ref="addProjectModal"
            no-close-on-backdrop
            no-close-on-esc
          >
            <Addproject
              @projectAdded="closeAddProjectModal"
              @refresh="refreshData"
              :assignee="assignee_options"
            />
          </b-modal>
          <b-button variant="primary" v-b-modal.modal-add-project>
            <feather-icon icon="PlusIcon" class="mr-50" />
            Add Project
          </b-button>
        </div>
      </b-col>
    </b-row>

    <div v-if="projects.length === 0 && !docloading">
      <b-row class="justify-content-center mt-3">
        <b-col md="6">
          <b-card>
            <b-card-body class="text-center">
              <h2>No projects available</h2>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- When Projects available show table -->
    <div class="d-block">
      <b-row class="justify-content-between">
        <b-col col="12" md="2" sm="2" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
            />
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          class="d-flex justify-content-end mb-2"
          style="position: relative; z-index: 1"
        >
          <b-button variant="outline-danger" @click="clearFilters">
            Clear Filters
          </b-button>
        </b-col>

        <b-col cols="12" v-if="!loading">
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="filteredProjects"
            :fields="fields"
            @filtered="onFiltered"
          >
            <!-- Project Name Filter -->
            <template #head(name)>
              <div class="d-flex flex-column">
                <span>Project Name *</span>
                <b-form-input
                  v-model="columnFilters.projectName"
                  placeholder="Filter by Project Name"
                  size="sm"
                  @input="filterTable"
                />
              </div>
            </template>

            <!-- Approver Filter -->
            <template #head(Approver)>
              <div class="d-flex flex-column">
                <span>Approver</span>
                <b-form-input
                  v-model="columnFilters.approver"
                  placeholder="Filter by Approver"
                  size="sm"
                  @input="filterTable"
                />
              </div>
            </template>

            <!-- Progress Filter -->
            <template #head(progress)>
              <div class="d-flex flex-column">
                <span>Progress</span>
                <b-form-select
                  v-model="columnFilters.progress"
                  :options="progressOptions"
                  size="sm"
                  @change="filterTable"
                >
                  <option :value="null">All</option>
                </b-form-select>
              </div>
            </template>

            <!-- Status Filter -->
            <template #head(status)>
              <div class="d-flex flex-column">
                <span>Status</span>
                <b-form-select
                  v-model="columnFilters.status"
                  :options="statusOptions"
                  size="sm"
                  @change="filterTable"
                >
                  <option :value="null">All</option>
                </b-form-select>
              </div>
            </template>

            <!-- Priority Filter -->
            <template #head(priority)>
              <div class="d-flex flex-column">
                <span>Priority</span>
                <b-form-select
                  v-model="columnFilters.priority"
                  :options="priorityOptions"
                  size="sm"
                  @change="filterTable"
                >
                  <option :value="null">All</option>
                </b-form-select>
              </div>
            </template>

            <template #cell(progress)="data">
              <b-badge :variant="progressMap[data.item.progress].variant">
                {{ progressMap[data.item.progress].text }}
              </b-badge>
            </template>

            <template #cell(Approver)="data">
              <div class="d-flex align-items-center">
                {{ getApproverName(data.item.approverId) }}
              </div>
            </template>

            <template #cell(status)="data">
              <b-badge :variant="statusMap[data.item.status].variant">
                {{ statusMap[data.item.status].text }}
              </b-badge>
            </template>

            <!-- Priority Column -->
            <template #cell(priority)="data">
              <b-badge :variant="priorityMap[data.item.priority].variant">
                {{ priorityMap[data.item.priority].text }}
              </b-badge>
            </template>
            <template v-slot:cell(actions)="data">
              <b-dropdown
                variant="link"
                toggle-class="p-0"
                no-caret
                class="m-1"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>

                <b-dropdown-item
                  v-if="
                    data.item.status === 'NOTSTARTED' &&
                    data.item.approverId === userId
                  "
                  @click="changeProjectStatus(data.item, 'APPROVED')"
                >
                  <feather-icon icon="CheckIcon" />
                  <span class="align-middle ml-50">Approve</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    data.item.status === 'NOTSTARTED' &&
                    data.item.approverId === userId
                  "
                  @click="changeProjectStatus(data.item, 'REMOVED')"
                >
                  <feather-icon icon="XIcon" />
                  <span class="align-middle ml-50">Reject</span>
                </b-dropdown-item>
                <!-- <b-dropdown-item @click="viewProject(data.item)"> -->
                <b-dropdown-item
                  :to="{
                    name: 'view-project',
                    params: { id: data.item.projectId },
                  }"
                >
                  <feather-icon icon="EyeIcon" />
                  <span class="align-middle ml-50">View</span>
                </b-dropdown-item>
                <!-- <b-dropdown-item v-b-modal.modal-edit-project @click="editProject(data.item)" v-if="
                  
                  data.item.status !== 'REMOVED'
                ">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Edit</span>
                </b-dropdown-item> -->
                <b-dropdown-item
                  @click="deleteProject(data.item)"
                  v-if="data.item.status === 'NOTSTARTED'"
                >
                  <feather-icon icon="TrashIcon" />
                  <span class="align-middle ml-50">Delete</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    data.item.status !== 'NOTSTARTED' &&
                    data.item.status !== 'REMOVED'
                  "
                  :to="{
                    name: 'milestones-list',
                    params: { id: data.item.projectId },
                  }"
                >
                  <feather-icon icon="FlagIcon" />
                  <span class="align-middle ml-50">Milestones</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    data.item.status !== 'NOTSTARTED' &&
                    data.item.status !== 'REMOVED'
                  "
                  :to="{
                    path: `/projectmanagement/tasks-list/${data.item.projectId}`,
                  }"
                >
                  <feather-icon icon="FileTextIcon" />
                  <span class="align-middle ml-50">Tasks</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    data.item.status !== 'NOTSTARTED' &&
                    data.item.status !== 'REMOVED'
                  "
                  :to="{
                    name: 'project-ganttchart',
                    params: { id: data.item.projectId },
                  }"
                >
                  <feather-icon icon="BarChart2Icon" />
                  <span class="align-middle ml-50">Gantt Chart</span>
                </b-dropdown-item>
                <b-dropdown-item @click="openKpiModal(data.item)">
                  <feather-icon icon="BarChartIcon" />
                  <span class="align-middle ml-50">KPI's</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="
                    data.item.status !== 'NOTSTARTED' &&
                    data.item.status !== 'REMOVED'
                  "
                  @click="viewProjectTestDocument(data.item)"
                >
                  <feather-icon icon="PaperclipIcon" />
                  <span class="align-middle ml-50">Documents</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>

          <b-modal
            id="modal-kpi-settings"
            title="KPI Settings"
            centered
            size="lg"
            ok-title="Save"
            @ok="saveKpiSettings"
          >
            <b-container>
              <b-row>
                <b-col md="12">
                  <b-form-group label="KPI Name 1" label-for="kpiName1">
                    <b-form-input
                      id="kpiName1"
                      v-model="project.kpiName1"
                      type="text"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="KPI Target 1" label-for="kpiTarget1">
                    <b-form-input
                      id="kpiTarget1"
                      v-model="project.kpiTarget1"
                      t
                      type="number"
                      :min="0"
                      step="0.01"
                      oninput="validity.valid||(value='');"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="KPI Value 1" label-for="kpiValue1">
                    <b-form-input
                      id="kpiValue1"
                      v-model="project.kpiValue1"
                      type="number"
                      :min="0"
                      step="0.01"
                      oninput="validity.valid||(value='');"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="KPI Name 2" label-for="kpiName2">
                    <b-form-input
                      id="kpiName2"
                      v-model="project.kpiName2"
                      ype="text"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="KPI Target 2" label-for="kpiTarget2">
                    <b-form-input
                      id="kpiTarget2"
                      v-model="project.kpiTarget2"
                      type="number"
                      :min="0"
                      step="0.01"
                      oninput="validity.valid||(value='');"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="12">
                  <b-form-group label="KPI Value 2" label-for="kpiValue2">
                    <b-form-input
                      id="kpiValue2"
                      v-model="project.kpiValue2"
                      type="number"
                      :min="0"
                      step="0.01"
                      oninput="validity.valid||(value='');"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-modal>

          <b-modal
            id="modal-view-project"
            ok-only
            ok-title="View"
            centered
            size="lg"
            title="View Project"
            :hide-footer="true"
          >
            <Editproject :project="currentProject" :actionType="'view'" />
          </b-modal>

          <b-modal
            id="modal-edit-project"
            ok-only
            ok-title="Edit"
            centered
            size="lg"
            title="Edit Project"
            :hide-footer="true"
          >
            <Editproject
              :project="currentProject"
              :assignee="assignee_options"
            />
          </b-modal>

          <b-modal
            ref="modal-view-testdocument"
            id="modal-view-testdocument"
            ok-only
            ok-title="View"
            centered
            size="lg"
            title="View Documents"
            :hide-footer="true"
          >
            <DocumentUpload
              @deleteFile="deleteFile"
              @downloadFile="downloadFile"
              @uploadFiles="uploadFiles"
              :documentDetails="documentDetails"
            />
          </b-modal>
        </b-col>

        <b-col cols="12">
          <div class="d-flex justify-content-center mb-1">
            <b-spinner
              variant="success"
              label="Spinning"
              block
              v-if="loading"
              style="width: 3rem; height: 3rem"
            ></b-spinner>
          </div>
          <b-pagination
            v-if="!loading"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BCardBody,
  BDropdown,
  BLink,
  BModal,
  VBModal,
  BDropdownItem,
} from "bootstrap-vue";

import Addproject from "./AddProject.vue";
import Editproject from "./EditProject.vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import DocumentUpload from "../component/DocumentUpload.vue";
import {
  deleteDocument,
  uploadMultipleDocuments,
  uploadDocument,
  downloadDocument,
} from "@/store/documentrepo/services";
import { customSwal, customError, customLoader } from "@/libs/customFn";
export default {
  components: {
    BCard,
    BCardBody,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BModal,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
    Addproject,
    Editproject,
    DocumentUpload,
    VBModal,
  },
  directives: {
    Ripple,
    "b-modal": VBModal,
  },
  data() {
    return {
      project: {
        kpiName1: null,
        kpiTarget1: null,
        kpiValue1: null,
        kpiName2: null,
        kpiTarget2: null,
        kpiValue2: null,
      },
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      currentProject: {},
      filterOn: [],
      columnFilters: {
        projectName: "",
        approver: "",
        progress: null,
        status: null,
        priority: null,
      },
      watch: {
        "project.kpiTarget1"(newValue) {
          if (newValue < 0) {
            this.project.kpiTarget1 = 0;
          }
        },
        "project.kpiValue1"(newValue) {
          if (newValue < 0) {
            this.project.kpiValue1 = 0;
          }
        },
        "project.kpiTarget2"(newValue) {
          if (newValue < 0) {
            this.project.kpiTarget2 = 0;
          }
        },
        "project.kpiValue2"(newValue) {
          if (newValue < 0) {
            this.project.kpiValue2 = 0;
          }
        },
      },
      progressOptions: [
        { value: "NOTSPECIFIED", text: "Not Specified" },
        { value: "ONTRACK", text: "On Track" },
        { value: "DELAYED", text: "Delayed" },
      ],
      statusOptions: [
        { value: "NOTSTARTED", text: "Not Started" },
        { value: "NEW", text: "New" },
        { value: "INPROGRESS", text: "In Progress" },
        { value: "ONHOLD", text: "On Hold" },
        { value: "COMPLETED", text: "Completed" },
        { value: "APPROVED", text: "Approved" },
        { value: "REMOVED", text: "Removed" },
      ],
      priorityOptions: [
        { value: "NOTSPECIFIED", text: "Not Specified" },
        { value: "LOW", text: "Low" },
        { value: "MEDIUM", text: "Medium" },
        { value: "HIGH", text: "High" },
      ],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      progressMap: {
        NOTSPECIFIED: { text: "Not Specified", variant: "secondary" },
        ONTRACK: { text: "On Track", variant: "success" },
        DELAYED: { text: "Delayed", variant: "danger" },
      },
      userId: null,
      statusMap: {
        NOTSTARTED: { text: "Not Started", variant: "secondary" },
        NEW: { text: "New", variant: "primary" },
        INPROGRESS: { text: "In Progress", variant: "info" },
        ONHOLD: { text: "On Hold", variant: "warning" },
        COMPLETED: { text: "Completed", variant: "success" },
        APPROVED: { text: "Approved", variant: "success" },
        REMOVED: { text: "Removed", variant: "dark" },
      },
      assignee_options: [],

      priorityMap: {
        NOTSPECIFIED: { text: "Not Specified", variant: "secondary" },
        LOW: { text: "Low", variant: "info" },
        MEDIUM: { text: "Medium", variant: "warning" },
        HIGH: { text: "High", variant: "danger" },
      },
      fields: [
        { key: "name", label: "Project Name", sortable: true },
        { key: "Approver", label: "Approver", sortable: true },
        { key: "progress", label: "Progress", sortable: true },
        // {
        //   key: "tasks.percentageTaskCompletion",
        //   label: "Progress %",
        //   formatter: "decimalPlaces",
        //   sortable: true,
        // },
        { key: "status", label: "Status", sortable: true },
        { key: "priority", label: "Priority", sortable: true },
        { key: "actions", label: "Actions" },
      ],

      Progressstatus: [
        {
          1: "NotStarted",
          2: "New",
          3: "InProgress",
          4: "OnHold",
          5: "Completed",
          6: "Approved",
          7: "Removed",
        },
        {
          1: "light-secondary",
          2: "light-dark",
          3: "light-info",
          4: "light-warning",
          5: "light-success",
          6: "light-danger",
          7: "light-secondary",
        },
      ],
      documentDetails: {
        isDelete: false,
        documentList: [],
      },
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },

    ...mapGetters("moduleConfig", ["itemuom", "loading"]),

    ...mapGetters("projectModule", {
      assignees: "assignees",
      loadingAssignee: "loading",
    }),
    ...mapGetters("projectModule", {
      projects: "projects",
      tasks: "tasks",
      loading: "loading",
    }),

    ...mapGetters("documentModule", {
      documents: "documents",
      file: "file",
      docloading: "docLoader",
    }),
    anyFilterActive() {
      const { projectName, approver } = this.columnFilters;
      return projectName || approver;
    },
    filteredProjects() {
      if (!this.projects || !Array.isArray(this.projects)) {
        return [];
      }
      console.log("Original projects data:", this.projects);
      return this.projects.filter((item) => {
        const matchesProjectName =
          !this.columnFilters.projectName ||
          (item.name &&
            item.name
              .toLowerCase()
              .includes(this.columnFilters.projectName.toLowerCase()));
        const matchesApprover =
          !this.columnFilters.approver ||
          (this.getApproverName(item.approverId) &&
            this.getApproverName(item.approverId)
              .toLowerCase()
              .includes(this.columnFilters.approver.toLowerCase()));
        const matchesProgress =
          !this.columnFilters.progress ||
          item.progress === this.columnFilters.progress;
        const matchesStatus =
          !this.columnFilters.status ||
          item.status === this.columnFilters.status;
        const matchesPriority =
          !this.columnFilters.priority ||
          item.priority === this.columnFilters.priority;

        return (
          matchesProjectName &&
          matchesApprover &&
          matchesProgress &&
          matchesStatus &&
          matchesPriority
        );
      });
    },
  },
  async mounted() {
    let userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = userData.id;
    await this.getProjectListAction()
      .then((response) => {
        console.log("Project List Response:", response);
        this.totalRows = this.projects.length;
      })
      .catch((response) => {
        console.log(response);
      });

    await this.getProjectAssigneesAction();
    this.assignee_options = this.assignees.map((assignee) => ({
      value: assignee.id,
      text: `${assignee.firstName} ${assignee.lastName}`,
    }));
  },
  methods: {
    getDefaultValue(value, defaultValue) {
      return value !== null && value !== undefined && value !== ""
        ? value
        : defaultValue;
    },
    async saveKpiSettings() {
      try {
        // Ensure currentProject is populated
        if (!this.currentProject || !this.currentProject.projectId) {
          customError("Project data is missing. Please select a project.");
          return;
        }

        const payload = {
          tasks: {
            overdueTasks: this.currentProject.tasks?.overdueTasks || 0,
            percentageTaskCompletion:
              this.currentProject.tasks?.percentageTaskCompletion || 0,
            totalTasks: this.currentProject.tasks?.totalTasks || 0,
            unplannedTasks: this.currentProject.tasks?.unplannedTasks || 0,
          },
          approverId: this.currentProject.approverId,
          assigneeId: this.currentProject.assigneeId,
          customerId: this.currentProject.customerId,
          customerName: this.currentProject.customerName,
          description: this.currentProject.description,
          endDate: this.currentProject.endDate,
          name: this.currentProject.name,
          priority: this.currentProject.priority,
          progress: this.currentProject.progress,
          progressName: this.currentProject.progressName,
          projectId: this.currentProject.projectId,
          startDate: this.currentProject.startDate,
          status: this.currentProject.status,
          supervisorId: this.currentProject.supervisorId,
          totalMilestones: this.currentProject.totalMilestones,
          totalTasks: this.currentProject.totalTasks,
          budget: this.currentProject.budget,
          expense: this.currentProject.expense,
          estimates: this.currentProject.estimates,
          kpiTarget1: this.project.kpiTarget1,
          kpiValue1: this.project.kpiValue1,
          kpiTarget2: this.project.kpiTarget2,
          kpiValue2: this.project.kpiValue2,
          kpiName1: this.project.kpiName1,
          kpiName2: this.project.kpiName2,
        };

        console.log("KPI update payload:", payload);

        let loader = customLoader("Updating KPI settings...");

        await this.updateProjectAction(payload);

        loader.close();
        customSwal("KPI settings updated successfully!");

        this.$bvModal.hide("modal-kpi-settings");

        await this.getProjectListAction();
      } catch (error) {
        console.error("Error updating KPI settings:", error);
        customError("Failed to update KPI settings. Please try again.");
      }
    },
    async openKpiModal(selectedProject) {
      try {
        console.log("Selected Project Data for KPI Modal:", selectedProject);

        // Set currentProject to selected project
        this.currentProject = { ...selectedProject };

        // Assign the selected project's KPI values
        this.project.kpiName1 = selectedProject.kpiName1;
        this.project.kpiTarget1 = selectedProject.kpiTarget1;
        this.project.kpiValue1 = selectedProject.kpiValue1;
        this.project.kpiName2 = selectedProject.kpiName2;
        this.project.kpiTarget2 = selectedProject.kpiTarget2;
        this.project.kpiValue2 = selectedProject.kpiValue2;

        // Show the KPI modal
        this.$bvModal.show("modal-kpi-settings");
      } catch (error) {
        console.error("Error while opening KPI modal:", error);
      }
    },
    filterTable() {
      this.currentPage = 1;
      this.totalRows = this.filteredProjects.length;
    },
    clearFilters() {
      // Clear each filter individually to trigger reactivity
      this.columnFilters.projectName = "";
      this.columnFilters.approver = "";
      this.columnFilters.progress = null; // Reset progress filter
      this.columnFilters.status = null; // Reset status filter
      this.columnFilters.priority = null; // Reset priority filter

      // Reapply filters and reset pagination
      this.filterTable();
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    decimalPlaces: (value) => value.toFixed(2),
    ...mapActions("projectModule", [
      "getProjectListAction",
      "removeProjectAction",
      "getProjectAssigneesAction",
      "getProjectTasksAction",
      "updateProjectAction",
    ]),

    editProject(project) {
      this.currentProject = project;
    },
    getApproverName(id) {
      const assignee = this.assignee_options.find(
        (option) => option.value === id
      );
      return assignee ? assignee.text : "-";
    },

    async viewProject(project) {
      this.currentProject = project;
      this.currentProject.percentage =
        project.tasks.percentageTaskCompletion.toFixed(2);
      this.$bvModal.show("modal-view-project");
    },

    async changeProjectStatus(project, status) {
      project.status = status;
      console.log("project.status = status:", status);
      let loader = customLoader("Please wait while status is being updated!");
      this.updateProjectAction(project)
        .then(() => {
          loader.close();

          if (status == "REMOVED") {
            customSwal(`Project has been rejected!`);
          } else {
            customSwal(`Project has been approved!`);
          }
        })
        .catch((ex) => {
          loader.close();
          this.error(ex.response.data);
          this.getProjectListAction()
            .then((response) => {
              console.log("Project List Response:", response);
              this.totalRows = this.projects.length;
            })
            .catch((response) => {
              console.log(response);
            });
        });
    },

    async viewProjectDocument(project) {
      this.currentProject = project;
    },

    async viewProjectTestDocument(project) {
      await this.getDocumentListAction({ id: project.projectId });
      this.documentDetails.documentList = this.documents;
      this.documentDetails.isDelete = true;
      this.currentProject = project;
      this.$nextTick(() => {
        this.$bvModal.show("modal-view-testdocument");
      });
      // this.$refs['modal-view-testdocument'].show();
    },

    async closeAddProjectModal() {
      this.$refs.addProjectModal.hide();
      await this.getProjectListAction()
        .then((response) => {
          this.totalRows = this.projects.length;
        })
        .catch((response) => {
          console.log(response);
        });

      this.totalRows = this.projects.length;
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    deleteProject(item) {
      let message = "You won't be able to revert this!";
      if (item.totalMilestones > 0 || item.totalTasks > 0) {
        message += ` This project has ${item.totalMilestones} milestones and ${item.totalTasks} tasks associated with it.`;
      }
      this.$swal({
        title: "Are you sure?",
        text: message,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$swal({
            title: "Deleting...",
            text: "Please wait while the Project are being deleted...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => {
              this.$swal.showLoading();
            },
          });

          this.removeProjectAction(item.projectId)
            .then((response) => {
              this.$swal.hideLoading();
              console.log("Delete response:", response);
              this.$swal.fire(
                "Deleted!",
                "Your Project have been deleted.",
                "success"
              );
              this.getProjectListAction()
                .then((response) => {
                  this.totalRows = this.projects.length;
                })
                .catch((response) => {
                  console.log(response);
                });
            })
            .catch((error) => {
              this.error(error.response.data);
            });
        }
      });
    },

    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: msg || " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(data) {
      let msg = null;
      if (data.errors) {
        let errors = data.errors;
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
      } else if (data.message) {
        msg = "<div>";
        msg += "<p>Cannot post your request due to the following errors:</p>";
        msg += data.message;
        msg += "</div>";
      }
      return msg;
    },
    refreshData() {},

    //#region Test Document

    ...mapActions("documentModule", [
      "getDocumentListAction",
      "fileSharingAction",
    ]),
    async downloadFile(id, fileName) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being prepared for download",
        onOpen: () => {
          loader.showLoading();
        },
        allowOutsideClick: () => !loader.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });

      try {
        const response = await downloadDocument(id);
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type:
              response.headers["content-type"] || "application/octet-stream",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); // Use the provided fileName parameter directly
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Clean up DOM by removing the link element after clicking
        window.URL.revokeObjectURL(url); // Free up memory by releasing object URL

        loader.close();
      } catch (error) {
        console.error("Download failed:", error);
        loader.close();
        this.error("Failed to download the file. Please try again."); // Updated error message for better clarity
      }
    },
    async uploadFiles(selectedFiles) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document(s) is being added",
        onOpen: () => {
          this.$swal.showLoading();
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        buttonsStyling: false,
        showConfirmButton: false,
      });
      const referenceId = this.currentProject.projectId;

      if (selectedFiles.length > 1) {
        await uploadMultipleDocuments(selectedFiles, referenceId)
          .then((response) => {
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      } else if (selectedFiles.length < 2) {
        await uploadDocument(selectedFiles, referenceId)
          .then((response) => {
            customSwal("Your file(s) have been successfully uploaded.");
            loader.close();
          })
          .catch((error) => {
            customError(error);
            loader.close();
          });
      }

      await this.getDocumentListAction({ id: referenceId });
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-testdocument");
      });
    },
    async deleteFile(id) {
      let loader = this.$swal({
        title: "Processing...",
        text: "Please wait while the document is being deleted",
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttonsStyling: false,
        showConfirmButton: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      await deleteDocument(id)
        .then((response) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customSwal();
        })
        .catch((error) => {
          loader.close();
          //this.$refs['modal-view-testdocument'].hide();
          customError(error);
        });

      await this.getDocumentListAction({ id: this.currentProject.projectId });
      this.documentDetails.documentList = this.documents;

      this.$nextTick(() => {
        this.$bvModal.show("modal-view-testdocument");
      });
    },

    //#endregion
  },
};
</script>
